import type { JSONContent } from '@tiptap/core';
import { v4 as uuid } from 'uuid';
import { ContentBlockType, GojsDiagramBlock, GojsDiagramModel } from '../../model';
import { BlockToTiptapConverter } from '../blocks-to-tiptap.converter';

export const convertGojsDiagramBlockToTiptap = ((block) => {
  return {
    type: 'gojsDiagram',
    attrs: {
      id: block.id,
      model: block.model,
      ...(block.layout_type && { layout_type: block.layout_type }),
      ...(block.height !== null && { height: block.height }),
      ...(block.custom_css && { custom_css: block.custom_css }),
      ...(block.custom_style && { custom_style: block.custom_style }),
      ...(block.hover_highlight && { hover_highlight: block.hover_highlight }),
    },
  };
}) satisfies BlockToTiptapConverter<GojsDiagramBlock>;

export function convertTiptapToGojsDiagramBlock(json: JSONContent): GojsDiagramBlock {
  const attrs = json.attrs ?? {};

  return {
    id: (attrs['id'] as string) ?? uuid(),
    type: ContentBlockType.GojsDiagram,
    model: (attrs['model'] as GojsDiagramModel) ?? { nodes: [], links: [] },
    ...(attrs['layout_type'] && { layout_type: attrs['layout_type'] as GojsDiagramBlock['layout_type'] }),
    ...(attrs['height'] !== null && { height: attrs['height'] as number }),
    ...(attrs['custom_css'] && { custom_css: attrs['custom_css'] as string }),
    ...(attrs['custom_style'] && { custom_style: attrs['custom_style'] as Record<string, string> }),
    ...(attrs['hover_highlight'] && { hover_highlight: attrs['hover_highlight'] as boolean }),
  };
}
